import { Icons } from '@commenda/kakashi';
import { cn } from '@commenda/utils';

interface ChatSendButtonProps {
  onClick: () => void;
  disabled?: boolean;
  'aria-label'?: string;
}

const ChatSendButton = ({
  onClick,
  disabled = false,
  'aria-label': ariaLabel = 'Send message',
}: ChatSendButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={cn(
        'flex items-center justify-center overflow-hidden rounded-full p-md shrink-0',
        disabled
          ? 'bg-fg-disabled cursor-not-allowed'
          : 'bg-fg-brand cursor-pointer hover:bg-fg-brand/80'
      )}
    >
      <Icons.ArrowUp className="size-5 text-white" />
    </button>
  );
};

export default ChatSendButton;
